import main from "../../Assets/main.jpg";
import React from "react";
import { Button } from "react-bootstrap";
import { withRouter } from 'react-router-dom'


class Home extends React.Component {
  state = {};
  

  render() {
    return (
      <div style={{ textAlign: "center" }} className="test-demo">
            <div>
            <img
                src={main}
                width="300"
                style={{ borderRadius: "50%", marginTop: "30px" }}
                className="d-inline-block align-top"
                alt="React Bootstrap logo"
            />
            </div>

            <div style={{marginTop:"60px"}}>
                <span>Running on Secure kubernetes Server 1</span><br></br>
                <Button onClick={()=>{
                    this.props.history.push('/login')
                }} variant="primary">I am a <b>Health Proffesional/ Foot Clinic/ General Practitioner</b></Button>{" "}
            </div>

            <div style={{marginTop:"30px"}}>
                <span>Running on Secure kubernetes Server 2</span> <br></br>
                <Button onClick={()=>{
                     this.props.history.push('/maps')
                }} style={{width:"480px"}} variant="primary">I am a <b>Patient/ User</b></Button>{" "}
            </div>

            <br></br>
            <br></br>

            <span>
              <b>GDPR COMPLIANT</b> - RUNNING ON SECURE AWS CLOUD SERVER IN VIRTUAL PRIVATE NETWORK
            </span>
          
      </div>
    );
  }
}

export default withRouter(Home);
